import * as React from "react";
import { AVAILABILITY_MONTHS } from "./availabilityMonths";

export function useAvailabilityMonths() {
  const getMonthName = React.useCallback((id: number) => {
    return AVAILABILITY_MONTHS.find((m) => m.id === id)?.name ?? "";
  }, []);

  return { getMonthName };
}
